import React from "react";
import { Link } from "react-router-dom";
import folderIcon from "../../assets/images/folderItem.png"; // Folder background

const FileCard = ({ file }) => {
  return (
    <Link to={`/files-manager/${file.id}`}>
      <div
        className="relative p-4 bg-transparent rounded "
        style={{
          width: "13rem", // Enini biraz büyüttüm
          height: "9rem",
          backgroundImage: `url(${folderIcon})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain", // Resmin oranını koruyarak folder içine oturtur
          backgroundPosition: "top center",
        }}
      >
        {/* Renkli ikon ve içindeki beyaz kare */}
        <div className="relative w-8 h-8 mb-3">
          <div
            className={`absolute w-full h-full rounded ${file.color}`}
            style={{
              backgroundColor: file.color,
            }}
          ></div>
          <div className="absolute w-4 h-4 bg-white top-2 left-2 rounded-sm"></div>
        </div>

        {/* Başlık ve tarih */}
        <div className="absolute bottom-4 left-4">
          <h3 className="text-sm font-medium text-gray-800 truncate">
            {file.name}
          </h3>
          <p className="text-xs text-gray-500">{file.date}</p>
        </div>
      </div>
    </Link>
  );
};

export default FileCard;
